import PremierLeagueIcon from "../assets/images/premier_league.svg";

// Single source of truth for "is this Premier League" - keyed on league
// name, not season_id. season_id changes every season (23614 last season,
// 25583 this one) and every render site that inlined its own season_id
// check has drifted out of sync with it at least once. League name is
// stable across seasons, so there's nothing to keep in sync.
export const isPremierLeague = (leagueName) =>
  typeof leagueName === "string" &&
  leagueName.trim().toLowerCase() === "premier league";

// Returns the bundled white Premier League crest for Premier League games,
// otherwise the SportMonks-hosted image the API gave us for that league.
export const getLeagueImage = (leagueName, fallbackImage) =>
  isPremierLeague(leagueName) ? PremierLeagueIcon : fallbackImage;
